import React, {Component} from 'react';
import AppHeader from '../../Misc/AppHeader';
import NotificationSystem from 'react-notification-system';
import Cookies from 'universal-cookie';
import {createCookie, getCookie,_addNotificationError} from '../../../server/util';
import {getAccessToken, validateParentAccount} from "../../../server/actionsParent";
import Fingerprint from 'fingerprintjs';
import PropTypes from "prop-types";
import { ROLES } from '../../../server/constants';


class ActivateParent extends Component {
    

    constructor(props, context) {
        super(props, context);
        //this.cookies = new Cookies();
        // this.Auth = new AuthService();
        this.state = {
            userName: "",
            logInUserRole: "",
            login_user: "",
            cookies: new Cookies(),
            isCookie: false,
            studentsList: []
        }
        this.validateUrl = this.validateUrl.bind(this);
        this.generateAccessToken = this.generateAccessToken.bind(this);
    }
    componentWillMount = () => {
        //generate token
        //getschool Id
        //login and get userinfo
        this.validateUrl();
    }
    validateUrl() {
        let queryString = window.location.search;

        var token = '';
        var parentEmail = '';
        if (queryString.length > 0) {
            token = decodeURIComponent(queryString.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('token').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            parentEmail = decodeURIComponent(queryString.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('parentId').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            if ((token == undefined ? '' : token) == '' || (parentEmail == undefined ? '' : token) == '') {
                this.context.router.history.push('/404')
                return false;
            }
        }
        else {
            // const cookies = new Cookies();
            let cookieData = getCookie('parent')
            const cookieObj = cookieData == '' ? undefined : (JSON.parse(cookieData) || undefined);
            if (cookieObj == undefined) {
                this.context.router.history.push('/404')
                return false;
            }
            token = cookieObj.token;
            parentEmail = cookieObj.email;
            console.log(cookieObj);
        }
        sessionStorage.setItem('ftoken', token);
        sessionStorage.setItem('loggedInUserInfo', parentEmail);
        sessionStorage.setItem('ROLE', 'ROLE_PARENT');
        let fp = new Fingerprint({
            canvas: true,
            ie_activex: true,
            screen_resolution: true
        });
        let reqBody = {
            'username': parentEmail,
            'fToken': token,
            'deviceId': fp.get()
        };
        sessionStorage.removeItem('validateresp');

        if (queryString.length > 0) {
            //alert(JSON.stringify(reqBody,null,2))
            validateParentAccount(reqBody).then((response) => {
                if (!response.ok) {
                    _addNotificationError('Invalid email/token.', this);
                    throw Error(response.message);
                }
                return response.json();
            }).then((data) => {
                this.generateAccessToken(reqBody.username, reqBody.fToken, reqBody.deviceId, data);
            })
                .catch(
                    (error) => {
                        console.log('Parent dashboard error', error);
                        this.context.router.history.push('/404')
                        return false;
                    }
                );
        } else {
            this.generateAccessToken(reqBody.username, reqBody.fToken, reqBody.deviceId, undefined);
        }
    }

    generateAccessToken(uname, ftoken, devId, valDevResp) {

        getAccessToken(uname, ftoken, ROLES.PARENT).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            //console.log('response', response);
            // this.setToken(response.token); // Setting the token in sessionStorage
            return response.json();
        }).then(respData => {
            sessionStorage.setItem('access_token', respData.access_token);
            sessionStorage.setItem('refresh_token', respData.refresh_token);

            if ((valDevResp == undefined ? '' : valDevResp.status) == 'Device not registered') {
                valDevResp.deviceId = devId;
                sessionStorage.setItem('validateresp', JSON.stringify(valDevResp));
                this.props.validateParent(valDevResp);
                this.context.router.history.push('/deviceRegister')
                return true;

            }
            else {
                /* const cookies = new Cookies();
                let expDate=new Date().setFullYear(new Date().getFullYear()+10)
                cookies.set('parent', JSON.stringify({'token':sessionStorage.getItem('ftoken'),'email':sessionStorage.getItem('loggedInUserInfo')}),
                 { path: '/' }); */
                createCookie('parent', JSON.stringify({'token': ftoken, 'email': uname}), 300);
                if(sessionStorage.getItem('bcacUrl')){
                    const _bcacUrl=sessionStorage.getItem('bcacUrl');
                    sessionStorage.removeItem('bcacUrl');
                    this.context.router.history.push(_bcacUrl);
                    return true;
                }else{
                    this.context.router.history.push('/parent');
                    return true;
                }
            }
        }).catch(
            (error) => {
                // alert("came here");
                // window.location.replace('/404');
                return false;
            }
        );

    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;

    }

    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>
                <AppHeader/>
            </div>
        );
    }

}

ActivateParent.contextTypes = {
    router: PropTypes.object.isRequired
}
export default ActivateParent;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/activateParent.jsx